// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QouT","title":"styles_title__1Li18"};